export default "__VITE_ASSET__BgSr29sI__"